import React from "react";
import styled from 'styled-components';

const Styled = styled.div`
  height: 32px;
  background: ${p => p.color};
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`;

export function SelectedColor(props) {
    const { value } = props;
    return <Styled color={value} />;
}
